import { useEffect, useState } from 'react';

interface UseOnlineReturn {
  isOnline: boolean;
  isOffline: boolean;
}

export default function useOnline(): UseOnlineReturn {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const goOnline = () => setIsOnline(true);
    const goOffline = () => setIsOnline(false);

    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return {
    isOnline,
    isOffline: !isOnline,
  };
}
